import { __awaiter, __generator } from 'tslib';
import { serializeComplexeParamsForRecoil, getUserThumbnailTemplatesSelector, thumbnailGenerationServiceConfigurationSelector, ThumbnailGenerationSourceMediaModeEnum, elementPermalinkQuerySelector, MediaLinksField } from '@keepeek/commons';
import { selectorFamily } from 'recoil';
import { MAX_THUMBNAIL_TEMPLATE_TO_LOAD } from '../../KFThumbnailGenerator/constants.js';
import { currentUserSelector } from '../users/selectors.js';
import { getResizeUrl } from './utils.js';

var generateResizedImagesFromImageServiceSelector = selectorFamily({
    key: "GsenerateResizedImagesFromImageServiceSelector",
    get: function (_a) {
        var element = _a.element, x = _a.x, y = _a.y, addExtensionAtEnd = _a.addExtensionAtEnd;
        return function (_a) {
            var get = _a.get;
            return __awaiter(void 0, void 0, void 0, function () {
                var currentUser, resourceSrc, result;
                return __generator(this, function (_b) {
                    currentUser = get(currentUserSelector);
                    if (!element || !currentUser) {
                        return [2 /*return*/, []];
                    }
                    resourceSrc = get(getElementSourceLinkForImageServiceSelector(serializeComplexeParamsForRecoil({ element: element })));
                    if (!resourceSrc) {
                        return [2 /*return*/, []];
                    }
                    result = get(getUserThumbnailTemplatesSelector({
                        userId: currentUser.id,
                        size: MAX_THUMBNAIL_TEMPLATE_TO_LOAD
                    }));
                    return [2 /*return*/, result && result._embedded
                            ? result._embedded["thumbnail-template"].map(function (p) {
                                return getResizeUrl({
                                    outWidth: p.width,
                                    outHeight: p.height,
                                    format: p.format,
                                    src: resourceSrc || "",
                                    poiX: x,
                                    poiY: y,
                                    addExtensionAtEnd: addExtensionAtEnd
                                });
                            })
                            : []];
                });
            });
        };
    }
});
var getElementSourceLinkForImageServiceSelector = selectorFamily({
    key: "GetElementSourceLinkForImageServiceSelector",
    get: function (_a) {
        var element = _a.element;
        return function (_a) {
            var get = _a.get;
            return __awaiter(void 0, void 0, void 0, function () {
                var techProThumbnailGeneration, sourceMediaMode;
                return __generator(this, function (_b) {
                    if (!element) {
                        return [2 /*return*/, []];
                    }
                    techProThumbnailGeneration = get(thumbnailGenerationServiceConfigurationSelector);
                    sourceMediaMode = techProThumbnailGeneration["source-media-mode"] ||
                        ThumbnailGenerationSourceMediaModeEnum.PERMALINK;
                    // in permalink mode, we need to made a call on media permalink before call image service :
                    if (sourceMediaMode === ThumbnailGenerationSourceMediaModeEnum.PERMALINK) {
                        get(elementPermalinkQuerySelector({ elementId: element.id }));
                        return [2 /*return*/, element._links && element._links[MediaLinksField.IMAGES_KPKP].href];
                    }
                    else {
                        return [2 /*return*/, element._links && element._links[MediaLinksField.IMAGES_KPK].href];
                    }
                });
            });
        };
    }
});

export { generateResizedImagesFromImageServiceSelector, getElementSourceLinkForImageServiceSelector };
//# sourceMappingURL=selectors.js.map
